import React, { useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import fleetBrand from '../../assets/images/logos/FleetWhite.png';
import './app-download.scss';

const PAGE_URL = `${window.location.origin}/download`;

const APP_STORE_URL = 'https://apps.apple.com/fr/app/fleet-akanea/id1523653744';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.fleetagrivitech';

function detectOS() {
  const ua = navigator.userAgent || navigator.vendor || window.opera;
  if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return 'ios';
  if (/android/i.test(ua)) return 'android';
  return 'other';
}

export default function AppDownload() {
  useEffect(() => {
    const os = detectOS();
    if (os === 'ios' && APP_STORE_URL) {
      window.location.replace(APP_STORE_URL);
    } else if (os === 'android' && PLAY_STORE_URL) {
      window.location.replace(PLAY_STORE_URL);
    }
  }, []);

  return (
    <div className="app-download-container">
      <div className="background-image" />
      <div className="app-download-content">
        <div className="app-download-card">
          <div className="logo-container">
            <img src={fleetBrand} alt="Fleet Logo" className="logo" />
          </div>
          <h1 className="download-title">Téléchargez l'application</h1>
          <p className="download-subtitle">Disponible sur iOS et Android</p>

          <div className="store-buttons">
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="store-btn store-btn--apple"
            >
              <svg
                className="store-icon"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
              </svg>
              <div className="store-btn-text">
                <span className="store-btn-label">Télécharger sur l'</span>
                <span className="store-btn-name">App Store</span>
              </div>
            </a>
            <a
              href={PLAY_STORE_URL || '#'}
              target="_blank"
              rel="noopener noreferrer"
              className={`store-btn store-btn--google${!PLAY_STORE_URL ? ' store-btn--disabled' : ''}`}
              onClick={!PLAY_STORE_URL ? (e) => e.preventDefault() : undefined}
            >
              <svg
                className="store-icon"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M3.18 23.76c.3.17.64.24.99.2l12.24-12.24L12.96 8.3 3.18 23.76zm17.14-10.5c.4-.7.4-1.82 0-2.52L18 8.96l-3.63 3.63L18 16.24l2.32-2.98zM3.54.04C3.24-.12 2.9-.04 2.6.14L15.63 11.8l-3.37 3.37L3.54.04zm9.42 12.55L1.72 23.83c.08.05.16.1.25.13.35.13.73.1 1.06-.09l11.78-6.52-1.85-4.76z" />
              </svg>
              <div className="store-btn-text">
                <span className="store-btn-label">Disponible sur</span>
                <span className="store-btn-name">Google Play</span>
              </div>
            </a>
          </div>
          <div className="qr-container">
            <QRCodeSVG
              value={PAGE_URL}
              size={160}
              bgColor="transparent"
              fgColor="#e8eaed"
              level="M"
            />
            <p className="qr-label">
              Scannez pour télécharger l'application FLEET
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
